import styled from 'styled-components'
import { media } from '@popety-io/ui'

export const ScrollableContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  /* Touch device optimizations */
  ${media.touch} {
    touch-action: pan-y;
    overscroll-behavior: contain;
  }

  /* Height calculation using CSS custom properties */
  --header-height: 48px;
  --tab-nav-height: 48px;
  --content-padding: 32px;
  --total-offset: calc(
    var(--header-height) + var(--tab-nav-height) + var(--content-padding)
  );

  height: calc(100dvh - var(--total-offset));

  /* Mobile adjustments */
  ${media.mobileOnly} {
    --header-height: 48px;
    --content-padding: 16px;
    max-height: calc(100dvh - 120px);
  }

  /* Tablet adjustments */
  ${media.mobile} {
    --content-padding: 24px;
  }

  /* Desktop */
  ${media.tablet} {
    --content-padding: 32px;
  }

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.secondary};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: ${({ theme }) => theme.borderRadius.small};

    &:hover {
      background: ${({ theme }) => theme.colors.border.focus};
    }
  }

  /* Smooth scrolling on non-touch devices */
  @media (hover: hover) {
    scroll-behavior: smooth;
  }

  /* Prevent content from being hidden under sticky elements */
  padding-bottom: ${({ theme }) => theme.spacing.large};

  /* Extra padding on mobile for FAB button (56px + 20px bottom margin + 16px buffer) */
  ${media.tabletDown} {
    padding-bottom: 92px;
  }
`

export const TabContentWrapper = styled(ScrollableContent)`
  padding: ${({ theme }) => theme.spacing.medium};
  padding-bottom: ${({ theme }) => theme.spacing.large};

  ${media.tabletDown} {
    padding: ${({ theme }) => theme.spacing.small};
    /* Extra padding for FAB button (56px + 20px bottom margin + 16px buffer) */
    padding-bottom: 92px;
  }
`
